import(/* webpackMode: "eager" */ "/codebuild/output/src405589514/src/apps/jumplab/src/app/error.tsx");
